////    CORE    ////
import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  Validators,
} from '@angular/forms'
import { Router } from '@angular/router'

////    SERVICES    ////
import { Banniere, BanniereService, LoaderButtonState } from '@helvetia/components'
import { ApiService } from 'src/app/services/api.service'


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public form: any

  constructor(
    private formBuilder: UntypedFormBuilder,
    public apiService: ApiService,
    private router: Router,
    private banniereService: BanniereService,
  ) {
 
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      identifiant: ['', Validators.required],
      password: ['', Validators.required],
    })

    if (localStorage.getItem('token')) {
      this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
        this.router.navigate(['documents'])
      })
    }
  }

  /**
   * Calls the api to check if the login/password matches a user
   * Redirect to the home page if the user exist.
   */
  submitForm(): void {
    if (!this.form.valid) {
      return
    }
    this.apiService.connection(this.form.get('identifiant').value, this.form.get('password').value).subscribe( 
      (data) => {
        let banniere = new Banniere()
        banniere.text = 'Connexion réussie'
        banniere.status = 'success'
        this.banniereService.setStatus(banniere)
        localStorage.setItem('token', data.token)

        this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
          this.router.navigate(['documents'])
        })
      })

  }
}
